var $bda17b3c68ec60e0$exports = {};
$bda17b3c68ec60e0$exports = {
    "Empty": `Tyhj\xe4`
};


export {$bda17b3c68ec60e0$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
